import axios from 'axios'

const axiosvl = axios.create({
    baseURL: process.env.VUE_APP_API
});

const vlResInterceptor = axiosvl.interceptors.response.use(res => {
 
    if(res.data.webroutine != undefined){
        const lists = res.data.webroutine.lists;
        const fields = res.data.webroutine.fields;

        for (var x in lists) { // Loop through each list returned by the webroutine

            const headerlist = [];

            for (const y in lists[x].header) { // Loop through each header entry
                const headers = lists[x].header[y];
                headers.name = headers.name.replace(/#/g, 'NUM');

                headerlist.push(headers.name);
            }

            for (const z in lists[x].entries) { // Loop on each JSON block in entries
                const jsonline = {};
                const entries = lists[x].entries[z];
                for (const a in entries) { // Loop on values
                    jsonline[headerlist[a]] = entries[a];
                }

                lists[x].entries.splice(z, 1, jsonline); // Replace the old record with the new key/value pair

            }
        }

        for (var f in fields) {
            if (f.includes('#')){
                // console.log(fields[f].value);
                const key = f.replace(/#/g, '');

                fields[key] = {
                    value: fields[f].value
                };
            }
        }
    }

    // Important: response interceptors **must** return the response.
    return res;
});

vlResInterceptor;

export default axiosvl;